'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const universal_color = require('../../../style/universal.color.js');

var mlbWhite = universal_color.mlbWhite,
    mlbGrey2 = universal_color.mlbGrey2,
    mlbGrey3 = universal_color.mlbGrey3,
    mlbGrey4 = universal_color.mlbGrey4,
    mlbBlack = universal_color.mlbBlack,
    focusBlue = universal_color.focusBlue;
var SortIndicator = styled__default.div.withConfig({
  displayName: "table-cellstyle__SortIndicator",
  componentId: "sc-xpntj7-0"
})(["display:inline-block;width:7px;height:7px;position:relative;svg{opacity:", ";width:7px;height:7px;left:-5px;position:absolute;&:first-child{top:-4px;}&:last-child{bottom:-2px;}transition-duration:.2s;}"], function (_ref) {
  var isSelected = _ref.isSelected;
  return isSelected ? 1 : 0;
});

var buildBorder = function buildBorder(before, backgroundColor) {
  return "\n  &:".concat(before ? 'before' : 'after', "{\n    content: '';\n    position: absolute;\n    ").concat(before ? 'left: 0px;' : 'right: 0px;', "\n    top: 0px;\n    height: 39px;\n    width: 1px;\n    display: inline;\n    background-color: ").concat(backgroundColor, ";\n  }\n");
};

var StyledTableCell = styled__default.td.withConfig({
  displayName: "table-cellstyle__StyledTableCell",
  componentId: "sc-xpntj7-1"
})(["font-size:13px;font-weight:500;text-align:", ";width:", ";position:relative;white-space:nowrap;color:", ";z-index:0;box-sizing:border-box;", " ", " ", " ", ""], function (_ref2) {
  var alignment = _ref2.alignment;
  return alignment;
}, function (_ref3) {
  var fixedWidth = _ref3.fixedWidth;
  return fixedWidth;
}, function (_ref4) {
  var dark = _ref4.dark;
  return dark ? mlbGrey2 : mlbBlack;
}, function (_ref5) {
  var columnHighlighted = _ref5.columnHighlighted,
      cellHighlighted = _ref5.cellHighlighted,
      highlightColor = _ref5.highlightColor;
  return !columnHighlighted && cellHighlighted ? "\n    background-color: ".concat(highlightColor, ";\n  ") : '';
}, function (_ref6) {
  var columnHighlighted = _ref6.columnHighlighted,
      lastRow = _ref6.lastRow,
      firstRow = _ref6.firstRow,
      highlightColor = _ref6.highlightColor,
      highlightHead = _ref6.highlightHead;
  return columnHighlighted ? "\n    background-color: ".concat(highlightColor, ";\n    ").concat(firstRow && !highlightHead ? "\n        border-top-right-radius: 4px;\n        border-top-left-radius: 4px;\n      " : '', "\n    ").concat(lastRow ? "\n        border-bottom-left-radius: 4px;\n        border-bottom-right-radius: 4px;\n      " : '', "\n  ") : '';
}, function (_ref7) {
  var colgroupStart = _ref7.colgroupStart,
      firstGroupStart = _ref7.firstGroupStart,
      colIndex = _ref7.colIndex,
      dark = _ref7.dark;
  return colgroupStart && firstGroupStart && colIndex > 0 ? buildBorder(true, dark ? mlbGrey4 : mlbGrey2) : '';
}, function (_ref8) {
  var colgroupEnd = _ref8.colgroupEnd,
      lastColumn = _ref8.lastColumn,
      dark = _ref8.dark;
  return colgroupEnd && !lastColumn ? buildBorder(false, dark ? mlbGrey4 : mlbGrey2) : '';
});
var StyledTableHead = styled__default.th.withConfig({
  displayName: "table-cellstyle__StyledTableHead",
  componentId: "sc-xpntj7-2"
})(["font-size:", ";font-weight:", ";color:", ";text-align:", ";width:", ";position:relative;white-space:nowrap;box-sizing:border-box;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none -moz-user-select:none;-ms-user-select:none;user-select:none;&:hover,&:focus{", "{svg{opacity:1;}}}", " ", " ", " ", " ", ""], function (_ref9) {
  var inHead = _ref9.inHead;
  return !inHead ? '13px' : '11px';
}, function (_ref10) {
  var inHead = _ref10.inHead;
  return !inHead ? '400' : '600';
}, function (_ref11) {
  var dark = _ref11.dark,
      inHead = _ref11.inHead;
  return dark ? !inHead ? mlbGrey2 : mlbGrey3 : !inHead ? mlbBlack : mlbGrey4;
}, function (_ref12) {
  var alignment = _ref12.alignment;
  return alignment;
}, function (_ref13) {
  var fixedWidth = _ref13.fixedWidth;
  return fixedWidth;
}, SortIndicator, function (_ref14) {
  var sortable = _ref14.sortable;
  return sortable ? "\n    cursor: pointer;\n    &:focus {\n      outline: ".concat(focusBlue, " auto 1px;\n    }\n  ") : '';
}, function (_ref15) {
  var columnHighlighted = _ref15.columnHighlighted,
      dark = _ref15.dark,
      highlightColor = _ref15.highlightColor;
  return columnHighlighted ? "\n    background-color: ".concat(highlightColor, ";\n    border-top-right-radius: 4px;\n    border-top-left-radius: 4px;\n    color: ").concat(dark ? mlbWhite : mlbBlack, ";\n    &:after {\n      content: '';\n      bottom: -6px;\n      left: 0px;\n      display: block;\n      position: absolute;\n      height: 5px;\n      background-color: ").concat(highlightColor, ";\n      width: 100%;\n    }\n  ") : '';
}, function (_ref16) {
  var normalHeader = _ref16.normalHeader,
      dark = _ref16.dark;
  return normalHeader ? "\n        border-bottom: 1px solid ".concat(dark ? mlbGrey4 : mlbGrey2, ";\n      ") : '';
}, function (_ref17) {
  var firstColPinned = _ref17.firstColPinned;
  return firstColPinned ? "\n      position: absolute;\n      left: 0;\n      z-index: 1;\n  " : '';
}, function (_ref18) {
  var lastColPinned = _ref18.lastColPinned;
  return lastColPinned ? "\n      position: absolute;\n      right: 0;\n      z-index: 1;\n  " : '';
});

exports.SortIndicator = SortIndicator;
exports.StyledTableCell = StyledTableCell;
exports.StyledTableHead = StyledTableHead;
